import { motion } from "framer-motion";
import { IMAGES } from "../data/content";

export default function Gallery({ t }) {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 md:py-32 bg-sand">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mb-12 md:mb-16 flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-bark mb-4">{t.gallery.overline}</p>
            <h2 className="font-serif font-light text-pine text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              {t.gallery.headingPre} <span className="italic text-terracotta">{t.gallery.headingAccent}</span>
            </h2>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-pine/50 max-w-xs leading-relaxed">
            {t.gallery.note}
          </p>
        </motion.div>

        <div className="grid grid-cols-12 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
          {IMAGES.gallery.map((img, i) => (
            <motion.figure
              key={img.src}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`relative overflow-hidden group ${img.span}`}
            >
              <img
                src={img.src}
                alt={t.gallery.captions[i] || img.caption}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover scale-[1.01] group-hover:scale-[1.06] transition-transform duration-700 ease-out"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-pine/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory">{t.gallery.captions[i] || img.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
